import StatisticDashboard from '@/pages/statistics/StatisticDashboard';

const TraderTransactionsSummary = () => <StatisticDashboard type="transactions" />;

export default TraderTransactionsSummary;
